import {get} from '@stubhub/rest-method';

const ComplianceModel = () => {
  return {
    get: ({listingId, storeId, headers: requestHeaders, ...args}) => {
      const path = `/compliance/v1/${listingId}/dsa?storeId=${storeId}`;
      const headers = {
        Authorization: process.env.REACT_APP_API_SECRET,
        ...requestHeaders,
      };

      return get({
        host: process.env.REACT_APP_API_HOST,
        path,
        headers,
        json: true,
        ...args,
      });
    },
  };
};

export default ComplianceModel;
